module.exports = __webpack_public_path__ + "img/Group-2.8224cbd3.png";